import styles from "./formModal.module.scss";
import Button from "../button/Button";
import {getSelectStyles} from "../../utils";
import Select from "react-select";
import React from "react";

export const fieldTypeOptions = Object.freeze({
  text: "text",
  dropdown: "dropdown",
  number: "number"
});

const FormModal = ({title, fields, onAbort, onSuccess, setData, successText, currValues, validationErrors, isDisabled, onFieldChange}) => {
  const valuesArray = Object.keys(fields).reduce((acc, curr, index) => (index % 2 === 0 ? acc.push([curr]) : acc[acc.length - 1].push(curr), acc), []);
  const getDefaultValue = (key) => {
    return fields[key]
      .values
      .filter(({value, label}) => {
        if (typeof value === "object") {
          return label === currValues[key]
        }
        return value === currValues[key]
      })[0]
  }
  return(
    <div className={styles.layout} key={JSON.stringify(fields)}>
      <div className={styles.modal}>
        <div className={styles.header}>
          <div className={styles.title}>{title}</div>
        </div>
        <table className={styles.body}>
          <tbody>
          {
            valuesArray.map(keysArray => (
              <tr key={keysArray} className={styles.tr}>
                {keysArray.map(key => {
                  if (fields[key].fieldType !== fieldTypeOptions.dropdown) {
                    return (
                      <td key={key} className={styles.td}>
                        <label>{fields[key].label}{fields[key].required && '*'}</label>
                        <input className={fields[key].readOnly && styles.readOnlyField} disabled={fields[key].readOnly} type={fields[key].fieldType} value={currValues && currValues[key]} onChange={(e) => {
                          onFieldChange({...fields[key], key }, e.target.value);
                          setData(prevState => ({...prevState, [key]: e.target.value}))
                        }} placeholder={fields[key].placeholder}/>
                        <p>{validationErrors[key]}</p>
                      </td>
                    )
                  } if (fields[key].fieldType === fieldTypeOptions.dropdown) {
                    return (
                      <td key={key} className={styles.td}>
                        <label>{fields[key].label}{fields[key].required && '*'}</label>
                        <Select
                          isDisabled={fields[key].readOnly}
                          placeholder={fields[key].placeholder}
                          defaultValue={getDefaultValue(key)}
                          onChange={({label, value}) => {
                            onFieldChange({...fields[key], key }, label);
                            setData(prevState => {
                              return {...prevState, [key]: value}
                            })
                          }}
                          options={fields[key].values}
                          styles={{
                            ...getSelectStyles(),
                            control: (defaultStyles) => ({
                              ...defaultStyles,
                              overflow: "hidden",
                              fontFamily: "UniversLTStd-Light",
                              width: "100%",
                              fontSize: ".82rem",
                              borderCollapse: "separate",
                              height: "2.9rem",
                              outline: "none",
                              borderRadius: ".5rem",
                            }),
                            placeholder:(defaultStyles)=>({
                              ...defaultStyles,
                              fontSize: ".82rem",
                            })
                          }
                          }
                        />
                        <p>{validationErrors[key]}</p>
                      </td>
                    )
                  }
                })}

              </tr>
            ))
          }
          </tbody>
        </table>
        <div className={styles.footer}>
          <Button style={styles.cancel} onClick={onAbort}>Cancel</Button>
          <div style={{width: '2.5rem'}}/>
          <Button onClick={onSuccess} style={styles.onSuccess}>{successText}</Button>
        </div>
      </div>
    </div>
  )
}

export default FormModal;
